/* eslint-disable no-alert */
import React from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import MarkerWithLabel from './MarkerWithLabel'
import helpers from '../helpers'

import utils from '../../../utils'

class OrderGuide extends React.Component {
  state = {
    merchantOrders: {},
    customerAddresses: [],

    blurredCustomers: [],
    selectedOrderKeys: [],
    selectedCustomerAddresses: [],
  }

  componentDidMount() {
    const { onMounted, orders } = this.props

    this.generateMerchantOrders(orders)
    onMounted(this)
  }

  componentWillReceiveProps(nextProps) {
    const { orders } = this.props

    if (orders !== nextProps.orders) {
      this.generateMerchantOrders(orders)
    }
  }

  generateMerchantOrders = (orders) => {
    const { groupedOrderKeys } = this.props
    const merchantOrders = {}
    const orderKeys = Object.keys(orders)
    const orderCount = orderKeys.length

    for (let index = 0; index < orderCount; index += 1) {
      const orderKey = orderKeys[index]
      const order = orders[orderKey]

      const branchKey =  order.restaurant.branch.key

      if (!groupedOrderKeys.includes(order.key) && order.status !== 'pending') {
        merchantOrders[branchKey] = merchantOrders[branchKey] || []
        merchantOrders[branchKey].push(order)
      }
    }

    this.setState({ merchantOrders })
  }

  onCreateGroup = () => {
    const { createNewGroup } = this.props
    const { selectedOrderKeys } = this.state

    if (selectedOrderKeys.length === 0) {
      alert('Please select order')
      return false
    }

    createNewGroup(selectedOrderKeys)
    return true
  }

  onClearMarkers = () => {
    this.setState({
      customerAddresses: [],
      selectedOrderKeys: [],
      blurredCustomers: [],
      selectedCustomerAddresses: []
    })
  }

  onOrderSelected = order => {
    const { key } = order
    const { customerAddresses, blurredCustomers, selectedOrderKeys, selectedCustomerAddresses} = this.state

    const deliveryAddressKey = `${order.deliveree}-${order.delivery_address}`
    const selectedCustomerKey = `${order.deliveree}-${order.delivery_address}-${order.key}`

    const newBlurredMarkers = Array.from(blurredCustomers)
    const newCustomerAddresses = Array.from(customerAddresses)
    const newSelectedOrderKeys = Array.from(selectedOrderKeys)
    const newSelectedCustomer = Array.from(selectedCustomerAddresses)

    const indexBlurredMarker = newBlurredMarkers.indexOf(key)
    const indexSelectedOrderKey = newSelectedOrderKeys.indexOf(key)
    const indexSelectedCustomer = newSelectedCustomer.indexOf(selectedCustomerKey)

    const addressData = {
      key: deliveryAddressKey,
      orderKey: order.key,
      name: order.deliveree_name,
      deliveryAddress: order.delivery_address,
      location: order.etaInfo.info.legs[0].end_location,
    }

    const reg = new RegExp(`${order.deliveree}-${order.delivery_address}`, "");

    const isSelectedOrder = indexSelectedCustomer !== -1 && indexSelectedOrderKey !== -1
    const isSelectedCustomer = newSelectedCustomer.map(add => reg.test(add)).includes(true)

    if (indexBlurredMarker > -1) {
      newBlurredMarkers.splice(indexBlurredMarker, 1)
      this.setState({ selectedOrderKeys: newBlurredMarkers })
      newCustomerAddresses.splice(indexBlurredMarker, 1)
    } else {
      newBlurredMarkers.push(key)
      newCustomerAddresses.push(addressData)
    }

    if (isSelectedOrder) {
      newSelectedOrderKeys.splice(indexSelectedOrderKey, 1)
      newSelectedCustomer.splice(indexSelectedCustomer, 1)
    }

    if (indexSelectedOrderKey === -1 && isSelectedCustomer) {
      newSelectedOrderKeys.push(key)
      newSelectedCustomer.push(selectedCustomerKey)
    }

    this.setState({
      blurredCustomers: newBlurredMarkers,
      selectedOrderKeys: newSelectedOrderKeys,
      customerAddresses: newCustomerAddresses,
      selectedCustomerAddresses: newSelectedCustomer,
    })
  }

  onMerchantMarkerClick = (orders) => {
    orders.forEach(this.onOrderSelected)
  }

  onCustomerClick = address => {
    const { selectedOrderKeys, selectedCustomerAddresses } = this.state
    const { orderKey, key } = address

    const selectedCustomerKey = `${key}-${orderKey}`

    const newSelectedOrderKeys = Array.from(selectedOrderKeys)
    const newSelectedCustomerAddresses = Array.from(selectedCustomerAddresses)

    const indexSelectedOrderKeys = newSelectedOrderKeys.indexOf(orderKey)
    const indexSelectedCustomer = newSelectedCustomerAddresses.indexOf(selectedCustomerKey)

    if (indexSelectedOrderKeys > -1) {
      newSelectedOrderKeys.splice(indexSelectedOrderKeys, 1)
    } else {
      newSelectedOrderKeys.push(orderKey)
    }

    if (indexSelectedCustomer > -1) {
      newSelectedCustomerAddresses.splice(indexSelectedCustomer, 1)
    } else {
      newSelectedCustomerAddresses.push(selectedCustomerKey)
    }

    this.setState({
      selectedOrderKeys: newSelectedOrderKeys,
      selectedCustomerAddresses: newSelectedCustomerAddresses,
    })
  }

  onCustomerMakerClick = addresses => {
    addresses.forEach(this.onCustomerClick)
  }

  renderMerchantMarker = merchantBranchKey => {
    const { merchantOrders, selectedOrderKeys, blurredCustomers } = this.state

    const orders = merchantOrders[merchantBranchKey]
    const order = orders[0]
    const isActive = selectedOrderKeys.includes(order.key) || blurredCustomers.includes(order.key)
    const label = `${order.restaurant.name} - ${order.restaurant.branch.name}`

    return (
      <MarkerWithLabel
        key={merchantBranchKey}
        opacity={isActive ? 1 : 0.5}
        location={order.etaInfo.info.legs[0].start_location}
        icon={helpers.icons.restaurant}
        label={label}
        labelColor={helpers.getLabelColor()}
        onClick={() => this.onMerchantMarkerClick(orders)}
      />
    )
  }

  renderCustomerMaker = addresses => {
    const { selectedOrderKeys } = this.state
    const { key, name, location, orderKey } = addresses[0]
    const label = addresses.length > 1 ? `${name} (${addresses.length})` : name

    const isActive = selectedOrderKeys.includes(orderKey)

    return (
      <MarkerWithLabel
        key={key}
        opacity={isActive ? 1 : 0.4}
        location={location}
        icon={helpers.icons.deliveryLocation}
        label={label}
        labelColor={helpers.getLabelColor('available')}
        onClick={() => this.onCustomerMakerClick(addresses)}
      />
    )
  }

  render() {
    const { merchantOrders, customerAddresses } = this.state

    const groupedCustomers = _.groupBy(customerAddresses, address => address.key)
    const customerKeys = Object.keys(groupedCustomers)
    const customerAddressCount = customerKeys.length

    const orderKeys = Object.keys(merchantOrders)
    const ordersCount = orderKeys.length

    const displayMarkers = []

    for (let index = 0; index < ordersCount; index += 1) {
      const order = orderKeys[index]
      displayMarkers.push(this.renderMerchantMarker(order))
    }

    for (let index = 0; index < customerAddressCount; index += 1) {
      const customerKey = customerKeys[index]
      const addresses = groupedCustomers[customerKey];
      displayMarkers.push(this.renderCustomerMaker(addresses))
    }

    return displayMarkers
  }
}

const mapState = ({ orders }) => {
  const deliveryOrders = _.filter(orders.todayOrders.attention, order => order.order_type !== 'pick-up')

  return {
    orders: utils.helpers.convertArrayToObject(deliveryOrders, 'key'),
  }
}

export default connect(mapState)(OrderGuide)



// WEBPACK FOOTER //
// ./src/containers/mapView/components/OrderGuideByMerchant.js